import { X } from 'lucide-react'
import { WorkspaceFileIcon } from '@/frontend/features/Fde/WorkspaceFileVisual'
import type { RepositoryFile } from '@/frontend/features/Fde/types'
import { cn } from '@/lib/utils'

interface Props {
  files: RepositoryFile[]
  activePath?: string
  onSelect: (path: string) => void
  onClose: (path: string) => void
  closeLabel: string
}

export default function WorkspaceFileTabs({ files, activePath, onSelect, onClose, closeLabel }: Props) {
  if (files.length === 0) return null
  return <div className="flex h-11 shrink-0 items-end gap-0.5 overflow-x-auto border-b border-border bg-muted/25 px-2 pt-1">
    {files.map((file) => <div
      key={file.path}
      className={cn(
        'group flex h-9 min-w-0 max-w-56 items-center rounded-t-lg border border-b-0 text-xs transition-colors',
        activePath === file.path ? 'border-border bg-background text-foreground' : 'border-transparent text-muted-foreground hover:bg-background/60 hover:text-foreground',
      )}
    >
      <button type="button" onClick={() => onSelect(file.path)} className="flex min-w-0 flex-1 items-center gap-2 py-2 pl-2.5">
        <WorkspaceFileIcon file={file} className="size-5 rounded-md [&_svg]:size-3" />
        <span className="truncate">{file.name}</span>
      </button>
      <button
        type="button"
        aria-label={`${closeLabel}: ${file.name}`}
        onClick={() => onClose(file.path)}
        className="mr-1.5 rounded p-0.5 opacity-40 hover:bg-muted group-hover:opacity-100"
      ><X className="size-3" /></button>
    </div>)}
  </div>
}
